import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const notifications = [{
  name: 'María G.',
  location: 'Buenos Aires',
  action: 'acaba de inscribirse',
  time: 'Hace 2 minutos'
}, {
  name: 'Carolina R.',
  location: 'Córdoba',
  action: 'se unió al Master',
  time: 'Hace 5 minutos'
}, {
  name: 'Valentina M.',
  location: 'Rosario',
  action: 'acaba de comprar',
  time: 'Hace 8 minutos'
}, {
  name: 'Sofía L.',
  location: 'Mendoza',
  action: 'se inscribió al curso',
  time: 'Hace 12 minutos'
}];
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState(0);
  useEffect(() => {
    const showNotification = () => {
      setCurrentNotification(Math.floor(Math.random() * notifications.length));
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(showNotification, 3000);
    // Then show every 12-18 seconds
    const interval = setInterval(() => {
      const randomDelay = 12000 + Math.random() * 6000;
      setTimeout(showNotification, randomDelay);
    }, 18000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const notification = notifications[currentNotification];
  return <AnimatePresence data-id="element-300">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-[9999]" style={{
      position: 'fixed',
      bottom: '1rem'
    }} data-id="element-301">
          <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-black/5 overflow-hidden" data-id="element-302">
            <div className="flex items-center gap-3 p-3" data-id="element-303">
              {/* Product Image - 1:1 Square */}
              <div className="flex-shrink-0 w-14 h-14 rounded-xl overflow-hidden bg-[#FAF8F4] border border-[#D4C4B0]/20" data-id="element-304">
                <img src="https://cdn.magicpatterns.com/uploads/4CLe7ye4HmUC8c4P3y1yos/3e5cb7a5-52f6-424d-9c23-d4e3b0a8931a.png" alt="Hydra Gloss Lips" className="w-full h-full object-cover" data-id="element-305" />
              </div>

              {/* Notification Content */}
              <div className="flex-1 min-w-0" data-id="element-306">
                <div className="flex items-start justify-between gap-2" data-id="element-307">
                  <div className="flex-1 min-w-0" data-id="element-308">
                    <p className="text-xs font-semibold text-[#3D3028] truncate" data-id="element-309">
                      HYDRA GLOSS LIPS™ 2.0
                    </p>
                    <p className="text-xs text-[#3D3028]/70 mt-0.5" data-id="element-310">
                      <span className="font-medium" data-id="element-311">{notification.name}</span>{' '}
                      de {notification.location}
                    </p>
                    <p className="text-xs text-[#3D3028]/70" data-id="element-312">
                      {notification.action}
                    </p>
                  </div>
                  <span className="text-[10px] text-[#3D3028]/50 whitespace-nowrap" data-id="element-313">
                    {notification.time}
                  </span>
                </div>
              </div>

              {/* Close Button */}
              <button onClick={() => setIsVisible(false)} className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-[#3D3028]/40 hover:text-[#3D3028]/70 transition-colors" aria-label="Cerrar notificación" data-id="element-314">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-315">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" data-id="element-316" />
                </svg>
              </button>
            </div>

            {/* iOS-style indicator bar */}
            <div className="h-1 bg-gradient-to-r from-[#E5A5A0] to-[#D4AF7A]" data-id="element-317" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}